import { Form, Select, Input } from "antd";
import { StepProps } from "./StepProps";
import { useTranslation } from "react-i18next";
import { multiSelectMaxCount } from "shared/helpers/multi-select-helpers";

const ThirdStep: React.FC<StepProps> = () => {
  const { t } = useTranslation();

  return (
    <div>
      <Form.Item
        name="moods"
        label={t("pages.Pitching.steps.third.moods")}
        rules={[
          {
            required: true,
          },
        ]}
      >
        <Select
          mode="multiple"
          options={[
            {
              label: t("pages.Pitching.steps.third.relax"),
              value: "Relax",
            },
            {
              label: t("pages.Pitching.steps.third.energia"),
              value: "Energia",
            },
            {
              label: t("pages.Pitching.steps.third.felicidade"),
              value: "Felicidade",
            },
            {
              label: t("pages.Pitching.steps.third.intensa"),
              value: "Intensa",
            },
            {
              label: t("pages.Pitching.steps.third.meditacao"),
              value: "Meditação",
            },
            {
              label: t("pages.Pitching.steps.third.romantico"),
              value: "Romântico",
            },
            {
              label: t("pages.Pitching.steps.third.tristeza"),
              value: "Tristeza",
            },
            {
              label: t("pages.Pitching.steps.third.sexy"),
              value: "Sexy",
            },
            {
              label: t("pages.Pitching.steps.third.nostalgia"),
              value: "Nostalgia",
            },
            {
              label: t("pages.Pitching.steps.third.inspiracional"),
              value: "Inspiracional",
            },
          ]}
          onChange={(value) => {
            multiSelectMaxCount(value, 2);
          }}
          showArrow
        />
      </Form.Item>
      <Form.Item
        name="musicStyles"
        label={t("pages.Pitching.steps.third.musicStyles")}
        rules={[
          {
            required: true,
          },
        ]}
      >
        <Select
          showArrow
          options={[
            {
              label: t("pages.Pitching.steps.third.acustico"),
              value: "Acústico",
            },
            {
              label: t("pages.Pitching.steps.third.balada"),
              value: "Balada",
            },
            {
              label: t("pages.Pitching.steps.third.batidas"),
              value: "Batidas",
            },
            {
              label: t("pages.Pitching.steps.third.experimental"),
              value: "Experimental",
            },
            {
              label: t("pages.Pitching.steps.third.festasFimAno"),
              value: "Festas de fim de ano",
            },
            {
              label: t("pages.Pitching.steps.third.criancas"),
              value: "Crianças",
            },
            {
              label: t("pages.Pitching.steps.third.tradicional"),
              value: "Tradicional",
            },
            {
              label: t("pages.Pitching.steps.third.nenhumaOpcoesAcima"),
              value: "Nenhuma das opções acima",
            },
          ]}
          mode="multiple"
          onChange={(value) => {
            multiSelectMaxCount(value, 2);
          }}
        />
      </Form.Item>
      <Form.Item
        name="instrumentsUsed"
        label={t("pages.Pitching.steps.third.instrumentsUsed")}
        rules={[
          {
            required: true,
          },
        ]}
      >
        <Select
          mode="multiple"
          showArrow
          options={[
            {
              label: t("pages.Pitching.steps.third.acordeao"),
              value: "Acordeão",
            },
            {
              label: t("pages.Pitching.steps.third.violao"),
              value: "Violão",
            },
            {
              label: t("pages.Pitching.steps.third.banjo"),
              value: "Banjo",
            },
            {
              label: t("pages.Pitching.steps.third.baixo"),
              value: "Baixo",
            },
            {
              label: t("pages.Pitching.steps.third.buzuq"),
              value: "Buzuq",
            },
            {
              label: t("pages.Pitching.steps.third.violoncelo"),
              value: "Violoncelo",
            },
            {
              label: t("pages.Pitching.steps.third.clarinete"),
              value: "Clarinete",
            },
            {
              label: t("pages.Pitching.steps.third.djembe"),
              value: "Djembe",
            },
            {
              label: t("pages.Pitching.steps.third.kitPercussao"),
              value: "Kit de percussão",
            },
            {
              label: t("pages.Pitching.steps.third.guitarraEletrica"),
              value: "Guitarra Elétrica",
            },
            {
              label: t("pages.Pitching.steps.third.erhu"),
              value: "Erhu",
            },
            {
              label: t("pages.Pitching.steps.third.flauta"),
              value: "Flauta",
            },
            {
              label: t("pages.Pitching.steps.third.gaita"),
              value: "Gaita",
            },
            {
              label: t("pages.Pitching.steps.third.harpa"),
              value: "Harpa",
            },
            {
              label: t("pages.Pitching.steps.third.kora"),
              value: "Kora",
            },
            {
              label: t("pages.Pitching.steps.third.bandolim"),
              value: "Bandolim",
            },
            {
              label: t("pages.Pitching.steps.third.mbira"),
              value: "Mbira",
            },
            {
              label: t("pages.Pitching.steps.third.oboe"),
              value: "Oboé",
            },
            {
              label: t("pages.Pitching.steps.third.orgao"),
              value: "Órgão",
            },
            {
              label: t("pages.Pitching.steps.third.oud"),
              value: "Oud",
            },
            {
              label: t("pages.Pitching.steps.third.guitarraHavaiana"),
              value: "Guitarra havaiana",
            },
            {
              label: t("pages.Pitching.steps.third.piano"),
              value: "Piano",
            },
            {
              label: t("pages.Pitching.steps.third.samples"),
              value: "Samples",
            },
            {
              label: t("pages.Pitching.steps.third.sanxian"),
              value: "Sanxian",
            },
            {
              label: t("pages.Pitching.steps.third.sarod"),
              value: "Sarod",
            },
            {
              label: t("pages.Pitching.steps.third.saxofone"),
              value: "Saxofone",
            },
            {
              label: t("pages.Pitching.steps.third.sitar"),
              value: "Sitar",
            },
            {
              label: t("pages.Pitching.steps.third.sintetizador"),
              value: "Sintetizador",
            },
            {
              label: t("pages.Pitching.steps.third.tabla"),
              value: "Tabla",
            },
            {
              label: t("pages.Pitching.steps.third.trombone"),
              value: "Trombone",
            },
            {
              label: t("pages.Pitching.steps.third.trompete"),
              value: "Trompete",
            },
            {
              label: t("pages.Pitching.steps.third.ukulele"),
              value: "Ukulele",
            },
            {
              label: t("pages.Pitching.steps.third.violino"),
              value: "Violino",
            },
            {
              label: t("pages.Pitching.steps.third.xilofone"),
              value: "Xilofone",
            },
          ]}
        />
      </Form.Item>
      <Form.Item
        name="isCover"
        label={t("pages.Pitching.steps.third.isCover")}
        rules={[
          {
            required: true,
          },
        ]}
      >
        <Select
          options={[
            {
              label: t("pages.Pitching.sim"),
              value: true,
            },
            {
              label: t("pages.Pitching.nao"),
              value: false,
            },
          ]}
        />
      </Form.Item>
      <Form.Item
        name="recorded"
        label={t("pages.Pitching.steps.third.recorded")}
        rules={[
          {
            required: true,
          },
        ]}
      >
        <Select
          options={[
            {
              label: "Estúdio",
              value: "Estúdio",
            },
            {
              label: "Ao vivo",
              value: "Ao vivo",
            },
          ]}
        />
      </Form.Item>
      <Form.Item
        name="isRemix"
        label={t("pages.Pitching.steps.third.isRemix")}
        rules={[
          {
            required: true,
          },
        ]}
      >
        <Select
          options={[
            {
              label: t("pages.Pitching.sim"),
              value: true,
            },
            {
              label: t("pages.Pitching.nao"),
              value: false,
            },
          ]}
        />
      </Form.Item>
      <Form.Item
        name="isInstrumental"
        label={t("pages.Pitching.steps.third.isInstrumental")}
        rules={[
          {
            required: true,
          },
        ]}
      >
        <Select
          options={[
            {
              label: t("pages.Pitching.sim"),
              value: true,
            },
            {
              label: t("pages.Pitching.nao"),
              value: false,
            },
          ]}
        />
      </Form.Item>
      <Form.Item
        name="language"
        label={t("pages.Pitching.steps.third.language")}
        rules={[
          {
            required: true,
          },
        ]}
      >
        <Input />
      </Form.Item>
    </div>
  );
};

export default ThirdStep;
